export const ORDER_NOTIFICATION = 'ORDER_NOTIFICATION';
export const ORDER_NOTIFICATION_FOR_OWNER = 'ORDER_NOTIFICATION_FOR_OWNER';
export const QUOTE_NOTIFICATION = 'QUOTE_NOTIFICATION';
export const QUOTE_NOTIFICATION_FOR_OWNER = 'QUOTE_NOTIFICATION_FOR_OWNER';